// import { sanitize } from 'dompurify';
import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { Heading3, spacing } from '../../theme';
import colors from '../../theme/variables/colors';
import {FormSectionElements, FormSubSections, ProgramContainer, SummaryStyleType } from '../../entities/formTemplateDataType';
import PasswordShowButtonCompnent from './PasswordShowButtonCompnent';
import PasswordHideButtonCompnent from './PasswordHideButtonCompnent';
import DataUtils from '../../utilities/DataUtils';
import { Address } from '../../runtimeComponent/subComponent/AddressSearchComponent';
import { getAddress } from '../../utilities/addressUtils';
import { getRootComponent, getSubSectionButton, getParentSection } from '../../utilities/ElementUtils';
import { ReactComponent as EditIcon } from "../../../public/assets/css/ontario-design-system/icons/svg/ontario-icon-edit.svg";
import UnorderList from '../subComponent/UnorderedList';
import {StyledText, StyledTextEllipsis, StyledTextTruncate, StyledTextWordWrap} from '../subComponent/step-indicator/styles';

const InfoElementContainer = styled.div`
    border-bottom: ${props => (props.className?.includes('notBordered') ? '0px' : '1px')} solid
        ${colors.palette.greyscale5};
    margin-top: ${spacing.spacing5};
    min-width: 253.33px;
`;
const InfoElementContainerTable = styled.div`
    border-bottom: ${props => (props.className?.includes('notBordered') ? '0px' : '2px')} solid ${colors.palette.greyscale5};
    margin-top: ${spacing.spacing5};
    min-width: 253.33px;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
    align-items: start;
    justify-content: space-between;
    gap: 1rem;
`;

const Headline = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const SplitRight = styled.div`
    width: 100%;
    display: flex;
    justify-content: ${props => (props.className === 'start' ? 'start' : 'space-between')};
    overflow: hidden;

    & > * {
        min-width: 0;
    }
`;

const SplitLeft = styled.div`
   width: 100%;
   display: flex;
    justify-content: ${props => (props.className === 'start' ? 'start' : 'flex-start')};
   gap: 1rem;
   overflow: hidden;
   button {
        margin-bottom: 2rem;
}
        
    & > * {
        min-width: 0;
`;

const Icon24Container = styled.div`
    display: flex;
    svg {
        height: 24px;
        width: 24px;
    }
`;
const StyledHeading = styled(Heading3)`
    display: flex;
    align-items: center;
    gap: ${spacing.spacing2};
    white-space: pre-line;
`;

interface Props {
    field: FormSectionElements;
    isEng: boolean;
    withButton: boolean;
    style?: SummaryStyleType;
    handleEditButtonClick?: (field: FormSectionElements) => void;
    callback: (programContainer: ProgramContainer) => void;
    children?: React.ReactNode;
}


export class InfoElementComponent extends React.Component<Props> {
    profile;

    constructor(props: Props) {
        super(props);
        
        this.props.field.mask=true;
        this.profile = this.props.field.parent.parent.parent.Profile;
    }

    findAddressElement = (summaryField: FormSectionElements) => {
        const root = getRootComponent(summaryField);
        let addressField: FormSectionElements;
        let find = false;
        
        for (const form of root.ListOfFormSections) {
            if (find) break;
            for (const subForm of form.ListOfFormSubSections) {
                const fields = subForm.ListOfFormSectionElements.filter(ele => (
                    ele.Datatype==='Address' && (ele.addressType ?? 'Residential') === (summaryField.addressType ?? 'Residential')
                ));

                if (fields.length) {
                    addressField = fields[0];
                    find = true;
                    break;
                }
            }
        }
        return addressField;
    }

    splitAddress=(wholeAddress?: Address): string => {
        if (!wholeAddress) return '';
        const address = getAddress(wholeAddress, this.props.field.mask, this.props.isEng ? 'en' : 'fr');
        // console.log(`masked address: ${address}`);
        return address;
    }

    splitAddressFromField = (summaryField: FormSectionElements) => {
        const addressField = this.findAddressElement(summaryField);
        if (addressField) {
            return this.splitAddress(addressField.Address)
        }
        return '';
    }
    
    sanitize(input) {
        return input ? input.replace(/<[^>]*>?/gm, '') : ''; // Removes HTML tags
    }
    render() {
        const field = this.props.field;
        const keepMaskLeft = getParentSection(field)?.DisplayMaskIconLeft;
        const SplitWrapper: React.ElementType = keepMaskLeft ? SplitLeft: SplitRight;
        const maskToggleButton =
                this.props.withButton && field.MaskInSummary ? (
                    field.mask ? (
                        <PasswordShowButtonCompnent
                            field={field}
                            callback={(programContainer) => {
                                this.props.callback(programContainer);
                            }}
                        />
                    ) : (
                        <PasswordHideButtonCompnent
                            field={field}
                            callback={(programContainer) => {
                                this.props.callback(programContainer);
                            }}
                        />
                    )
                ) : null;
        const isEng = this.props.isEng;
        const label = isEng ? field.ENUTitle : field.FRATitle;
        let value;
        if (field.MaskInSummary) {
            switch (field.Datatype) {
                case "ODSDateRange":
                    if (field.mask) {
                        value = "****/**/** - ****/**/**";
                    } else if (field?.Value) {
                        const parts = String(field.Value).split('|');
                        const startDate = parts[0] || '';
                        const endDate = parts[1] || '';
                        value = `${startDate || 'N/A'} - ${endDate || 'N/A'}`;
                    }
                    break;
                case "ODSDate":
                    if (field.mask) {
                        value = "****/**/**";
                    } else if (field?.DateDisplayFormat && field?.Value) {
                        const momentDate = moment(field.Value);
                        if (momentDate?.isValid()) {
                            value = momentDate.format(field.DateDisplayFormat);
                        } else {
                            value = field.Value;
                        }
                    } else {
                        value = field.Value;
                    }
                    break;
                case "Address":
                    // value= this.splitAddress((field.Address || this.profile?.address) as Address | undefined)
                    value = this.splitAddressFromField(field)
                    break;
                case "Email":
                const emailParts = field.Value?.split('@');
                let maskedValue = emailParts[0].substring(0, 2) + '******';
                if (emailParts.length > 1) {
                    const emailDomainParts = emailParts[1].split('.');
                    maskedValue += `@${emailDomainParts[0].substring(0, 1)}*****`;
                    if (emailDomainParts.length > 1) {
                        maskedValue += `.${emailDomainParts[1]}`;
                    }
                }
                value = field.mask? maskedValue:field.Value;
            break;
                default:
                    if (field.mask) {
                        const len = field.Value?.length;
                        if (len > 3) {
                            value = DataUtils.maskString(field.Value, 0, len - 3);
                        } else if (len) {
                            value = '****';
                        }
                    } else {
                        value = field.Value;
                    }
                    break;
            }
        } else {
            value = field.Value;
        }
      
        //const value = field.mask ? DataUtils.maskString(field.Value, 0, 3) : field.Value;
        return (
            <>
                {(this.props.style !== 'Table') && <InfoElementContainer className={`info-element notBordered`}>
                    <Headline>
                        <StyledHeading styledAs="h4">
                            {label}
                            {/* {!field.Valid && (
                                <Icon24Container>
                                    <WarningIcon />
                                </Icon24Container>
                            )} */}
                        </StyledHeading>
                        {(this.props.style === 'Link' || this.props.style === 'All') && (
                            <button style={{display: 'flex', alignItems: 'start', border: 'none', backgroundColor: '#fff', cursor: 'pointer', textDecoration: 'underline', padding: '0.25rem 0'}} 
                                title={this.props.isEng ? "Edit" : "Modifier"}
                                onClick={() => {
                                    const subSectionButton = getSubSectionButton(field.parent as FormSubSections);
                                    this.props.handleEditButtonClick(subSectionButton)
                                }}
                            >
                                <EditIcon aria-hidden='true' fill='#00478f'/>
                                <span style={{color: "#00478f", fontSize: "1.2rem"}}>{this.props.isEng ? "Change" : "Modifier"}</span>
                            </button>
                        )}
                    </Headline>
                    <SplitWrapper id="infoelementsplit">
                        
                        {keepMaskLeft && maskToggleButton}
                        {this.props.field.Datatype!=='UnorderList' && this.props.field?.parent?.CustomizedSummaryTextElementStyle?.val === 'ellipsis' && <StyledTextEllipsis
                            dangerouslySetInnerHTML={{
                                __html: value ,
                            }}
                        />} 
                        {this.props.field.Datatype!=='UnorderList' && this.props.field?.parent?.CustomizedSummaryTextElementStyle?.val === 'truncate' && <StyledTextTruncate
                            dangerouslySetInnerHTML={{
                                __html: value ,
                            }}
                        />} 
                        {this.props.field.Datatype!=='UnorderList' && this.props.field?.parent?.CustomizedSummaryTextElementStyle?.val === 'word-wrap' && <StyledTextWordWrap
                            dangerouslySetInnerHTML={{
                                __html: value ,
                            }}
                        />} 
                        {this.props.field.Datatype!=='UnorderList' && !this.props.field?.parent?.CustomizedSummaryTextElementStyle?.val && <StyledText
                            dangerouslySetInnerHTML={{
                                __html: value ,
                            }}
                        />} 
                        {this.props.field.Datatype=='UnorderList' && <UnorderList isEng={this.props.isEng}
                            field={field} callback={(programContainer: ProgramContainer) => {
                                this.props.callback(programContainer);
                            }} />
                        }
                         
                        {!keepMaskLeft && maskToggleButton}
                    </SplitWrapper>
                  
                    {this.props.children}
                </InfoElementContainer>}
                {(this.props.style === 'Table') && <InfoElementContainerTable className={`info-element notBordered`}>
                    <Headline>
                        <StyledHeading styledAs="h4">
                            {label}
                        </StyledHeading>
                    </Headline>
                    <SplitRight id="infoelementsplit">
                        {this.props.field.Datatype!=='UnorderList' && this.props.field?.parent?.CustomizedSummaryTextElementStyle?.val === 'ellipsis' && <StyledTextEllipsis
                            dangerouslySetInnerHTML={{
                                __html: value ,
                            }}
                        />} 
                        {this.props.field.Datatype!=='UnorderList' && this.props.field?.parent?.CustomizedSummaryTextElementStyle?.val === 'truncate' && <StyledTextTruncate
                            dangerouslySetInnerHTML={{
                                __html: value ,
                            }}
                        />} 
                        {this.props.field.Datatype!=='UnorderList' && this.props.field?.parent?.CustomizedSummaryTextElementStyle?.val === 'word-wrap' && <StyledTextWordWrap
                            dangerouslySetInnerHTML={{
                                __html: value ,
                            }}
                        />} 
                        {this.props.field.Datatype!=='UnorderList' && !this.props.field?.parent?.CustomizedSummaryTextElementStyle?.val && <StyledText
                            dangerouslySetInnerHTML={{
                                __html: value ,
                            }}
                        />} 
                        {this.props.field.Datatype=='UnorderList' && <UnorderList isEng={this.props.isEng}
                            field={field} callback={(programContainer: ProgramContainer) => {
                                this.props.callback(programContainer);
                            }} />
                        }
                        {this.props.withButton && field.MaskInSummary ?
                            field.mask
                                ? <PasswordShowButtonCompnent field={field} callback={(programContainer) => {
                                    this.props.callback(programContainer);
                                }} />
                                : <PasswordHideButtonCompnent field={field} callback={(programContainer) => {
                                        this.props.callback(programContainer);
                                }} /> : null}                    
                    </SplitRight>
                  
                    {this.props.children}
                </InfoElementContainerTable>}
            </>
        )
    }
}
